"use strict";

exports.__esModule = true;
exports.tooltipTheme = void 0;

var _themes = require("../themes");

var _themes2 = require("../Popover/themes"); // $FlowFixMe - strict theme keys incompatible with mapComponentThemes


var tooltipTheme = function tooltipTheme(baseTheme) {
  return (0, _themes.mapComponentThemes)({
    name: 'Popover',
    theme: (0, _themes2.popoverTheme)(baseTheme)
  }, {
    name: 'Tooltip',
    theme: {
      TooltipArrow_backgroundColor: baseTheme.panel_backgroundColor_inverted,
      TooltipArrow_borderColor: baseTheme.panel_borderColor_inverted,
      TooltipContent_backgroundColor: baseTheme.panel_backgroundColor_inverted,
      TooltipContent_borderColor: baseTheme.panel_borderColor_inverted,
      TooltipContent_color: baseTheme.color_inverted,
      TooltipContent_maxWidth: '18em',
      TooltipContentBlock_marginVertical: '0',
      TooltipContentBlock_paddingHorizontal: baseTheme.space_inset_md,
      TooltipTriggerText_borderStyle: 'dashed',
      TooltipTriggerText_borderColor: 'currentcolor',
      TooltipTriggerText_borderWidth: '1px'
    }
  }, baseTheme);
};

exports.tooltipTheme = tooltipTheme;